"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeviceInfo = exports.Code = exports.codes = exports.NAMESPACE = exports.Zip = exports.ThinkWater = exports.Quench = exports.Culligan = exports.Adt = void 0;
const effect_1 = require("effect");
const Adt = __importStar(require("./adt"));
const Culligan = __importStar(require("./culligan"));
const Quench = __importStar(require("./quench"));
const ThinkWater = __importStar(require("./think-water"));
const Zip = __importStar(require("./zip"));
exports.Adt = __importStar(require("./adt"));
exports.Culligan = __importStar(require("./culligan"));
exports.Quench = __importStar(require("./quench"));
exports.ThinkWater = __importStar(require("./think-water"));
exports.Zip = __importStar(require("./zip"));
exports.NAMESPACE = 'Culligan.Device.Vendor';
exports.codes = {
    adt: Adt.DeviceInfo,
    cul: Culligan.DeviceInfo,
    qnc: Quench.DeviceInfo,
    thn: ThinkWater.DeviceInfo,
    zip: Zip.DeviceInfo,
};
exports.Code = effect_1.Schema.Union(Adt.Code, Culligan.Code, Quench.Code, ThinkWater.Code, Zip.Code).annotations({
    identifier: `${exports.NAMESPACE}.Code`,
});
exports.DeviceInfo = effect_1.Schema.Union(Adt.DeviceInfo, Culligan.DeviceInfo, Quench.DeviceInfo, ThinkWater.DeviceInfo, Zip.DeviceInfo).annotations({
    identifier: `${exports.NAMESPACE}.DeviceInfo`,
});
//# sourceMappingURL=index.js.map